import * as React from 'react';
import { debounce } from 'lodash';
import { InputBaseModel } from '../models';
import { WorksheetModel, BalanceInformationNodeModel } from '../models';
import { useAppStore } from '../stores';

export default (input: InputBaseModel) => {
    const { worksheetsStore } = useAppStore();

    const debouncedCalculateNetDue = React.useMemo(
        () =>
            debounce((worksheet: WorksheetModel, balanceNode: BalanceInformationNodeModel) => {
                worksheet.calculateNetDue([balanceNode]);
            }, 500),
        []
    );

    const triggerNetDueCalculation = React.useCallback(() => {
        const selectedWorksheet = worksheetsStore.selectedWorksheet;

        if (!selectedWorksheet) {
            return;
        }

        const balanceNode = selectedWorksheet.balanceInformationNodes.find(node =>
            node.entryCodeNodes.some(entryCodeNode =>
                entryCodeNode.inputs.some(entryCodeInput => entryCodeInput.guid === input.guid)
            )
        );

        if (balanceNode) {
            debouncedCalculateNetDue(selectedWorksheet, balanceNode);
        }
    }, [input.guid, worksheetsStore.selectedWorksheet, debouncedCalculateNetDue]);

    return { triggerNetDueCalculation };
};
